import { render, staticRenderFns } from "./btnGroups.vue?vue&type=template&id=3b9b40cc&scoped=true"
import script from "./btnGroups.vue?vue&type=script&lang=js"
export * from "./btnGroups.vue?vue&type=script&lang=js"
import style0 from "./btnGroups.vue?vue&type=style&index=0&id=3b9b40cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9b40cc",
  null
  
)

export default component.exports